/* eslint-disable no-unused-expressions */
import React, { useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import block from 'bem-cn';

import SVG from 'components/SVG';

import { addNotify } from 'features/notify';

import downloadSVG from '../../img/download.svg';
import useImageInput from '../../model/useImageInput';

import './InputPhoto.scss';

const b = block('input-photo-mobile');

const InputPhoto = ({ currentImageData, name, onImageChange, url, sizeLimit = 40960, withUrlUpload = false, ...restProps }) => {
  const dispatch = useDispatch();
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const ref = useRef(null);

  const withImage = Boolean(currentImageData.image);

  const handleImgChange = useImageInput({ sizeLimit });

  useEffect(() => {
    if (withUrlUpload) {
      const handleUrlLoad = async () => {
        if (url) {
          try {
            const response = await fetch(url);

            if (!response.ok) {
              throw new Error('Ошибка сети');
            }

            const data = await response.blob();

            let mimeType = data.type;
            if (mimeType === 'application/gzip' && url.endsWith('.webp')) {
              mimeType = 'image/webp';
            }

            const file = new File([data], url, { type: mimeType });
            const imageData = await handleImgChange(file);
            if (onImageChange && imageData.image) onImageChange(imageData);
          } catch (error) {
            console.error('Ошибка загрузки изображения:', error);
            dispatch(addNotify(locale.imageLoadError?.replace('<url>', url || ''), 'error'));
          }
        }
      };

      handleUrlLoad();
    }
  }, [url]);

  const handleDragPrevent = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleImageDrop = async e => {
    e.preventDefault();
    e.stopPropagation();
    const imageData = await handleImgChange(e.dataTransfer.files);
    if (onImageChange) onImageChange(imageData);
  };

  const handleFileChange = async e => {
    const imageData = await handleImgChange(e.currentTarget.files);
    if (onImageChange) onImageChange(imageData);
  };

  const text = currentImageData.image?.name || url || `${locale.load}...`;

  const handleResetFile = () => {
    if (ref.current && ref.current.value) {
      ref.current.value = '';
    }
  }

  return (
    <label
      className={b({ withImage: withImage || !!url })}
      onDragEnter={handleDragPrevent}
      onDragOver={handleDragPrevent}
      onDrop={handleImageDrop}
      onClick={handleResetFile}
    >
      <input
        className={b('native')}
        type="file"
        name={name}
        accept=".jpeg,.png,.jpg,.gif,.webp"
        onChange={handleFileChange}
        ref={ref}
        {...restProps}
      />
      <div className={b('text')}>{text}</div>
      <SVG className={b('download')} svgProps={{ svg: downloadSVG }} />
    </label>
  );
};

export default InputPhoto;
